module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/bodyWash_8af358.png";